import { Component, EventEmitter, Input, Output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "rft-confirmation-modal",
  templateUrl: "./confirmation-modal.component.html",
  styleUrls: ["./confirmation-modal.component.scss"],
})
export class ConfirmationModalComponent {
  @Input() public heading: string = "";
  @Input() public closeSingle: boolean = false;
  @Output() public cancelEvent = new EventEmitter<void>();
  @Output() public confirmEvent = new EventEmitter<void>();

  public constructor(private readonly _dialog: MatDialog) {}

  public onCancelEvent(): void {
    this.cancelEvent.emit();
    this._dialog.closeAll();
  }

  public onConfirmEvent(): void {
    this.confirmEvent.emit();
    this._dialog.closeAll();
  }

  public onConfirmEventSingle(): void {
    this.confirmEvent.emit();
  }
}
